import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-account-edit',
  templateUrl: './icon-account-edit.component.html',
  styleUrl: './icon-account-edit.component.scss',
  standalone: false,
})
export class IconAccountEditComponent {
  @Input() tooltip?: string;
}
